const spielklassen =[
	{value: 'minis', label: 'Minis', short: 'Minis'},
	{value: 'jugend', label: 'Jugend', short: 'Jugend'},
	{value: 'wj1114', label: 'Weibliche Jugend 11-14', short: 'WJ 11-14'},
	{value: 'wj1518', label: 'Weibliche Jugend 15-18', short: 'WJ 15-18'},
	{value: 'mj1114', label: 'Männliche Jugend 11-14', short: 'MJ 11-14 '},
	{value: 'mj1518', label: 'Männliche Jugend 15-18', short: 'MJ 15-18'},
	{value: 'mlk', label: 'Männer LK', short: 'M LK'},
	{value: 'flk', label: 'Frauen LK', short: 'F LK'},
	{value: 'f35', label: 'Frauen AK 35', short: 'F 35'},
	{value: 'f30', label: 'Frauen AK 30', short: 'F 30'},
	{value: 'f40', label: 'Frauen AK 40', short: 'F 40'},
	{value: 'm30', label: 'Männer AK 30', short: 'M 30'},
	{value: 'm40', label: 'Männer AK 40', short: 'M 40'},   
	{value: 'm45', label: 'Männer AK 45', short: 'M 45'},   
	{value: 'm50', label: 'Männer AK 50', short: 'M 50'},   
	{value: 'm55', label: 'Männer AK 55', short: 'M 55'},   
	{value: 'm60', label: 'Männer AK 60', short: 'M 60'},
	{value: 'fz', label: 'Freizeit', short: 'Fz'},
	{value: 'mixed', label: 'Mixed', short: 'Mix'}    
];

export default spielklassen;